import { render, staticRenderFns } from "./JobsWidget.vue?vue&type=template&id=40573aed&"
import script from "./JobsWidget.vue?vue&type=script&lang=js&"
export * from "./JobsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports